module.exports = __webpack_public_path__ + "img/schedule_sp.85bae732.svg";